import { StaticQuery, Link } from 'gatsby'
import React, { useState, useRef } from 'react'
import styled from 'styled-components'

import Menu from './menu'

import { useScrollPosition } from '../lib/helpers'

const StyledHeader = styled.header`
  position: fixed;
  width: 100vw;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  z-index: 20;

  h1 {
    font-family: 'Playfair-display', serif;
  }
  
  background-color: ${props => props.invisible ? 'rgba(0,0,0, 0)' : 'rgba(255,255,255, 1)'};
  color: ${props => props.invisible ? 'white' : 'black'};
  box-shadow: ${props => props.invisible ? 'none' : 'rgba(0, 0, 0, 0.1) 0px 0px 2px 3px'};

  padding-bottom: ${props => props.invisible ? 'none' : '70px'};

  transition: all .2s ease-in-out;
  height: 70px;
  
  svg {
    display: block;
  }

  box-sizing: border-box;
  padding: 0px 60px;
  @media only screen and (max-width: 1200px) {
    padding: 0px 30px;
  }

  div {
    width:33%;
    text-align: center;
  }

  a {
    text-decoration: none;
    color: inherit;
  }
`

const Header = ({ onHideNav, onShowNav, showNav, className, scrollNav }) => {
  const [hideOnScroll, setHideOnScroll] = scrollNav ? useState(true) : useState(false)

  if (scrollNav !== undefined) {
    useScrollPosition(({ prevPos, currPos }) => {
      const isShow = currPos.y > -70
      if (isShow !== hideOnScroll) setHideOnScroll(isShow)
    }, [hideOnScroll])
  }

  return (
    <StyledHeader className={className} invisible={hideOnScroll}>
      <Menu onHideNav={onHideNav} onShowNav={onShowNav} showNav={showNav} />
      <div >
        <Link to='/'><h1>EiT</h1></Link>
      </div>
      <div></div>
    </StyledHeader>
  )
}


export default Header
